import camelcaseKeys from 'camelcase-keys';

import { groupBy, handleError, handleSuccess, triggerDelete, triggerGet, triggerPost } from './utils';

const getProvidersWithUsers = async () => {
  const [providersResponse, providerUsersResponse] = await Promise.all([triggerGet('/business/providers'), triggerGet('/business/users/providers')]);
  const [providersResponseData, providerUsersResponseData] = await Promise.all([providersResponse.json(), providerUsersResponse.json()]);

  if (providersResponseData.report.status === 404 || providerUsersResponseData.report.status === 404) {
    return { success: true, data: [] };
  }

  if (providersResponseData.report.status !== 200 || providerUsersResponseData.report.status !== 200) {
    return { success: false };
  }

  const providers = camelcaseKeys(providersResponseData.data || {});
  const providerUsers = groupBy('providersId')(camelcaseKeys(providerUsersResponseData.data || []));

  const data = providers.map(x => ({ ...x, users: providerUsers[x.providersId] }));
  return { success: true, data };
};

const getProvidersApiRequest = async includeUsers => {
  if (includeUsers) {
    return getProvidersWithUsers();
  }

  const apiResponse = await triggerGet('/business/providers?recs=1000&pg=1&sc=0&so=d');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    responseData.data.reverse();
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const getProviderDetailsApiRequest = async providerId => {
  const apiResponse = await triggerGet(`/business/providers/${providerId}`);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData, true);
  }
  return handleError(responseData);
};

const getProviderSchedule = async () => {
  const apiResponse = await triggerGet('/business/schedules');
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const getProviderBreaks = async () => {
  const apiResponse = await triggerGet('/business/breaks');
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const addProviderSchedule = async data => {
  const apiResponse = await triggerPost('/business/schedules', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const addProviderBreaks = async data => {
  const apiResponse = await triggerPost('/business/breaks', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

const deleteProviderBreaks = async () => {
  const apiResponse = await triggerDelete('/business/breaks');
  if (apiResponse.status === 200) {
    return { success: true, data: [], report: {} };
  }
  return handleError({ report: { status: 'error' } });
};

export {
  addProviderBreaks,
  addProviderSchedule,
  deleteProviderBreaks,
  getProviderBreaks,
  getProviderDetailsApiRequest,
  getProvidersApiRequest,
  getProviderSchedule,
};
